import React from 'react';
import { ChevronIcon } from '@sainsburys-tech/bolt-icons';
import { DrawerContent as BoltDrawerContent } from '@sainsburys-tech/bolt';
import * as Styled from './DrawerContent.styles';
import ColourAndFabricPicker from '../ColourAndFabricPicker/ColourAndFabricPicker';
import LegFinishPicker from '../LegFinishPicker/LegFinishPicker';
import FabricTag from '../FabricTag/FabricTag';
import { ATTRIBUTE_TYPE, fabrics, fabricDescription, aboutFabricText } from '../../config';
import { UPDATE_ATTRIBUTE_TYPE } from '../../types';
import { trackAboutOurFabricsButton } from '../../helpers/trackingUtils';

var DrawerContent = function DrawerContent(props) {
  var attributeType = props.attributeType,
      selectedProduct = props.selectedProduct,
      dispatch = props.dispatch,
      productVariants = props.productVariants,
      currentVariant = props.currentVariant,
      pageType = props.pageType;
  var backToSwatchesButton = /*#__PURE__*/React.createElement(Styled.FabricInfoBackButton, {
    kind: "link",
    onClick: function onClick() {
      // Display the Colour & Fabric picker on click
      dispatch({
        type: UPDATE_ATTRIBUTE_TYPE,
        payload: ATTRIBUTE_TYPE === null || ATTRIBUTE_TYPE === void 0 ? void 0 : ATTRIBUTE_TYPE.FABRIC_TYPE
      });
    }
  }, /*#__PURE__*/React.createElement(ChevronIcon, {
    dir: "left",
    height: 24,
    width: 24,
    fill: "#0C509F"
  }), /*#__PURE__*/React.createElement("span", null, "Back to swatches"));

  var getContentByType = function getContentByType(type) {
    switch (type) {
      case ATTRIBUTE_TYPE === null || ATTRIBUTE_TYPE === void 0 ? void 0 : ATTRIBUTE_TYPE.FABRIC_TYPE:
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.AboutFabricButtonWrapper, {
          onClick: function onClick() {
            trackAboutOurFabricsButton(pageType);
            dispatch({
              type: UPDATE_ATTRIBUTE_TYPE,
              payload: ATTRIBUTE_TYPE === null || ATTRIBUTE_TYPE === void 0 ? void 0 : ATTRIBUTE_TYPE.FABRIC_INFO
            });
          }
        }, /*#__PURE__*/React.createElement(Styled.AboutFabricText, {
          "data-test": "drawer-content-fabric-text"
        }, aboutFabricText), /*#__PURE__*/React.createElement(Styled.AboutFabricIconWrapper, null, /*#__PURE__*/React.createElement(ChevronIcon, {
          dir: "right",
          height: 24,
          width: 24,
          fill: "#262626"
        }))), /*#__PURE__*/React.createElement(ColourAndFabricPicker, {
          productVariants: productVariants,
          selectedProduct: selectedProduct,
          currentVariant: currentVariant,
          dispatch: dispatch
        }));

      case ATTRIBUTE_TYPE === null || ATTRIBUTE_TYPE === void 0 ? void 0 : ATTRIBUTE_TYPE.FEET_COLOUR:
        return /*#__PURE__*/React.createElement(LegFinishPicker, {
          selectedProduct: selectedProduct,
          productVariants: productVariants,
          currentVariant: currentVariant,
          dispatch: dispatch
        });

      case ATTRIBUTE_TYPE === null || ATTRIBUTE_TYPE === void 0 ? void 0 : ATTRIBUTE_TYPE.FABRIC_INFO:
        return /*#__PURE__*/React.createElement(React.Fragment, null, backToSwatchesButton, /*#__PURE__*/React.createElement(Styled.AboutFabricsTitle, null, aboutFabricText), fabricDescription && /*#__PURE__*/React.createElement(Styled.AlertWrapper, null, /*#__PURE__*/React.createElement(Styled.Alert, {
          kind: "info",
          isCloseable: false
        }, fabricDescription)), fabrics.length > 0 && fabrics.map(function (fabric) {
          var _fabric$tags;

          return /*#__PURE__*/React.createElement(Styled.AboutFabricWrapper, {
            key: fabric === null || fabric === void 0 ? void 0 : fabric.heading
          }, /*#__PURE__*/React.createElement(Styled.AboutFabricHeading, null, fabric === null || fabric === void 0 ? void 0 : fabric.heading), (fabric === null || fabric === void 0 ? void 0 : (_fabric$tags = fabric.tags) === null || _fabric$tags === void 0 ? void 0 : _fabric$tags.length) > 0 && /*#__PURE__*/React.createElement(Styled.AboutFabricTagWrapper, null, fabric.tags.map(function (tag) {
            return /*#__PURE__*/React.createElement(FabricTag, {
              key: tag,
              label: tag
            });
          })), /*#__PURE__*/React.createElement(Styled.AboutFabricDescription, null, fabric === null || fabric === void 0 ? void 0 : fabric.description), (fabric === null || fabric === void 0 ? void 0 : fabric.composition) && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "Composition:"), " ", fabric === null || fabric === void 0 ? void 0 : fabric.composition));
        }), /*#__PURE__*/React.createElement(Styled.FabricInfoButtonWraper, null, backToSwatchesButton));

      default:
        return '';
    }
  };

  var content = getContentByType(attributeType);
  if (!content) return null;
  return /*#__PURE__*/React.createElement(BoltDrawerContent, null, content);
};

export default DrawerContent;